import React from 'react';

interface DrgRow {
  weight?: number;
}

/**
 * Weight template with 4 decimal places
 */
export const WeightTemplate: React.FC<{ weight: number | null | undefined }> = ({ weight }) => {
  const value = weight ?? 0;
  return <span>{value.toFixed(4)}</span>;
};

// Template function for grid column
export const weightTemplate = (props: DrgRow) => <WeightTemplate weight={props.weight} />;

export default WeightTemplate;
